import { useCallback, useState } from 'react';
function resolveNextValue(valueOrUpdater, previousValue) {
    if (typeof valueOrUpdater === 'function') {
        return valueOrUpdater(previousValue);
    }
    return valueOrUpdater;
}
export function useControllableState({ value, defaultValue, onChange, }) {
    const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
    const isControlled = value !== undefined;
    const effectiveValue = isControlled ? value : uncontrolledValue;
    const setValue = useCallback((valueOrUpdater) => {
        const nextValue = resolveNextValue(valueOrUpdater, effectiveValue);
        if (!isControlled) {
            setUncontrolledValue(nextValue);
        }
        onChange?.(nextValue);
    }, [effectiveValue, isControlled, onChange]);
    return [effectiveValue, setValue];
}
//# sourceMappingURL=useControllableState.js.map